import { AppData, Fach } from "../types";

export const getDefaultFaecher = (): Omit<Fach, "id">[] => {
  return [
    {
      kuerzel: "D",
      name: "Deutsch",
      basislektionen: 26,
      basislektionenAltersentlastung: 24,
      pflichtfach: { 1: true, 2: true, 3: true, 4: true, 5: true, 6: true },
      freifach: { 1: false, 2: false, 3: false, 4: false, 5: false, 6: false },
      hk: { 1: false, 2: false, 3: true, 4: true, 5: true, 6: true },
    },
    {
      kuerzel: "F",
      name: "Französisch",
      basislektionen: 26,
      basislektionenAltersentlastung: 24,
      pflichtfach: { 1: true, 2: true, 3: true, 4: true, 5: true, 6: true },
      freifach: { 1: false, 2: false, 3: false, 4: false, 5: false, 6: false },
      hk: { 1: false, 2: false, 3: true, 4: true, 5: true, 6: true },
    },
    {
      kuerzel: "E",
      name: "English",
      basislektionen: 26,
      basislektionenAltersentlastung: 24,
      pflichtfach: { 1: true, 2: true, 3: true, 4: true, 5: true, 6: true },
      freifach: { 1: false, 2: false, 3: false, 4: false, 5: false, 6: false },
      hk: { 1: false, 2: false, 3: true, 4: true, 5: true, 6: true },
    },
    {
      kuerzel: "M",
      name: "Mathematik",
      basislektionen: 26,
      basislektionenAltersentlastung: 24,
      pflichtfach: { 1: true, 2: true, 3: true, 4: true, 5: true, 6: true },
      freifach: { 1: false, 2: false, 3: false, 4: false, 5: false, 6: false },
      hk: { 1: false, 2: false, 3: false, 4: false, 5: false, 6: false },
    },
    {
      kuerzel: "Bio",
      name: "Biologie",
      basislektionen: 25,
      basislektionenAltersentlastung: 24,
      pflichtfach: { 1: true, 2: true, 3: true, 4: true, 5: true, 6: true },
      freifach: { 1: false, 2: false, 3: false, 4: false, 5: false, 6: false },
      hk: { 1: false, 2: false, 3: false, 4: false, 5: false, 6: false },
    },
    {
      kuerzel: "Chem",
      name: "Chemie",
      basislektionen: 25,
      basislektionenAltersentlastung: 24,
      pflichtfach: { 1: true, 2: true, 3: true, 4: true, 5: true, 6: true },
      freifach: { 1: false, 2: false, 3: false, 4: false, 5: false, 6: false },
      hk: { 1: false, 2: false, 3: false, 4: false, 5: false, 6: false },
    },
    {
      kuerzel: "Phys",
      name: "Physik",
      basislektionen: 25,
      basislektionenAltersentlastung: 24,
      pflichtfach: { 1: true, 2: true, 3: true, 4: true, 5: true, 6: true },
      freifach: { 1: false, 2: false, 3: false, 4: false, 5: false, 6: false },
      hk: { 1: false, 2: false, 3: false, 4: false, 5: false, 6: false },
    },
    {
      kuerzel: "Gg",
      name: "Geografie",
      basislektionen: 25,
      basislektionenAltersentlastung: 24,
      pflichtfach: { 1: true, 2: true, 3: true, 4: true, 5: true, 6: true },
      freifach: { 1: false, 2: false, 3: false, 4: false, 5: false, 6: false },
      hk: { 1: false, 2: false, 3: false, 4: false, 5: false, 6: false },
    },
    {
      kuerzel: "G",
      name: "Geschichte",
      basislektionen: 25,
      basislektionenAltersentlastung: 24,
      pflichtfach: { 1: true, 2: true, 3: true, 4: true, 5: true, 6: true },
      freifach: { 1: false, 2: false, 3: false, 4: false, 5: false, 6: false },
      hk: { 1: false, 2: false, 3: false, 4: false, 5: false, 6: false },
    },
    {
      kuerzel: "BG",
      name: "Bildnerisches Gestalten",
      basislektionen: 23,
      basislektionenAltersentlastung: 21,
      pflichtfach: { 1: true, 2: true, 3: false, 4: false, 5: false, 6: false },
      freifach: { 1: false, 2: false, 3: false, 4: false, 5: false, 6: false },
      hk: { 1: true, 2: true, 3: false, 4: false, 5: false, 6: false },
    },
    {
      kuerzel: "Mu",
      name: "Musik",
      basislektionen: 23,
      basislektionenAltersentlastung: 21,
      pflichtfach: { 1: true, 2: true, 3: false, 4: false, 5: false, 6: false },
      freifach: { 1: false, 2: false, 3: false, 4: false, 5: false, 6: false },
      hk: { 1: false, 2: false, 3: false, 4: false, 5: false, 6: false },
    },
    {
      kuerzel: "L",
      name: "Latein",
      basislektionen: 26,
      basislektionenAltersentlastung: 24,
      pflichtfach: { 1: false, 2: false, 3: false, 4: false, 5: false, 6: false },
      freifach: { 1: false, 2: false, 3: true, 4: true, 5: true, 6: true },
      hk: { 1: false, 2: false, 3: true, 4: true, 5: true, 6: true },
      profileConfig: {
        "L/E": {
          pflichtfach: { 1: false, 2: false, 3: true, 4: true, 5: true, 6: true },
          freifach: { 1: false, 2: false, 3: false, 4: false, 5: false, 6: false },
          hk: { 1: false, 2: false, 3: true, 4: true, 5: true, 6: true },
        },
      },
    },
    {
      kuerzel: "I",
      name: "Italienisch",
      basislektionen: 26,
      basislektionenAltersentlastung: 24,
      pflichtfach: { 1: false, 2: false, 3: false, 4: false, 5: false, 6: false },
      freifach: { 1: false, 2: false, 3: true, 4: true, 5: true, 6: true },
      hk: { 1: false, 2: false, 3: true, 4: true, 5: true, 6: true },
      profileConfig: {
        "I/E": {
          pflichtfach: { 1: false, 2: false, 3: true, 4: true, 5: true, 6: true },
          freifach: { 1: false, 2: false, 3: false, 4: false, 5: false, 6: false },
          hk: { 1: false, 2: false, 3: true, 4: true, 5: true, 6: true },
        },
      },
    },
    {
      kuerzel: "Sp",
      name: "Spanisch",
      basislektionen: 26,
      basislektionenAltersentlastung: 24,
      pflichtfach: { 1: false, 2: false, 3: false, 4: false, 5: false, 6: false },
      freifach: { 1: false, 2: false, 3: true, 4: true, 5: true, 6: true },
      hk: { 1: false, 2: false, 3: true, 4: true, 5: true, 6: true },
      profileConfig: {
        "Sp/E": {
          pflichtfach: { 1: false, 2: false, 3: true, 4: true, 5: true, 6: true },
          freifach: { 1: false, 2: false, 3: false, 4: false, 5: false, 6: false },
          hk: { 1: false, 2: false, 3: true, 4: true, 5: true, 6: true },
        },
      },
    },
    {
      kuerzel: "Inf",
      name: "Informatik",
      basislektionen: 25,
      basislektionenAltersentlastung: 24,
      pflichtfach: { 1: true, 2: true, 3: true, 4: true, 5: true, 6: true },
      freifach: { 1: false, 2: false, 3: false, 4: false, 5: false, 6: false },
      hk: { 1: false, 2: false, 3: false, 4: false, 5: false, 6: false },
    },
    {
      kuerzel: "Sport",
      name: "Sport",
      basislektionen: 23,
      basislektionenAltersentlastung: 21,
      pflichtfach: { 1: true, 2: true, 3: true, 4: true, 5: true, 6: true },
      freifach: { 1: false, 2: false, 3: false, 4: false, 5: false, 6: false },
      hk: { 1: false, 2: false, 3: false, 4: false, 5: false, 6: false },
    },
    {
      kuerzel: "W&R",
      name: "Wirtschaft & Recht",
      basislektionen: 25,
      basislektionenAltersentlastung: 24,
      pflichtfach: { 1: false, 2: false, 3: true, 4: true, 5: true, 6: true },
      freifach: { 1: false, 2: false, 3: false, 4: false, 5: false, 6: false },
      hk: { 1: false, 2: false, 3: false, 4: false, 5: false, 6: false },
    },
    {
      kuerzel: "Phil",
      name: "Philosophie",
      basislektionen: 25,
      basislektionenAltersentlastung: 24,
      pflichtfach: { 1: false, 2: false, 3: false, 4: false, 5: false, 6: false },
      freifach: { 1: false, 2: false, 3: true, 4: true, 5: true, 6: true },
      hk: { 1: false, 2: false, 3: false, 4: false, 5: false, 6: false },
    },
    {
      kuerzel: "Psych",
      name: "Psychologie",
      basislektionen: 25,
      basislektionenAltersentlastung: 24,
      pflichtfach: { 1: false, 2: false, 3: false, 4: false, 5: false, 6: false },
      freifach: { 1: false, 2: false, 3: true, 4: true, 5: true, 6: true },
      hk: { 1: false, 2: false, 3: false, 4: false, 5: false, 6: false },
    },
  ];
};

export const getDemoData = (): AppData => {
  // Generate all faecher with IDs
  const defaultFaecher = getDefaultFaecher();
  const faecher: Fach[] = defaultFaecher.map((f, idx) => ({
    ...f,
    id: `F${String(idx + 1).padStart(3, "0")}`,
  }));

  // Helper to get fach ID by kuerzel
  const getFachId = (kuerzel: string) =>
    faecher.find((f) => f.kuerzel === kuerzel)?.id || "";

  // Lehrpersonen with diverse subjects
  const lehrpersonen = [
    { id: "LP001", name: "Müller", faecher: ["D", "G"], solllektionen: 26, bemerkungen: "" },
    { id: "LP002", name: "Meier", faecher: ["D", "E"], solllektionen: 23, bemerkungen: "" },
    { id: "LP003", name: "Schmidt", faecher: ["F", "I"], solllektionen: 21, bemerkungen: "" },
    { id: "LP004", name: "Weber", faecher: ["M", "Phys"], solllektionen: 26, bemerkungen: "" },
    { id: "LP005", name: "Fischer", faecher: ["M", "Inf"], solllektionen: 23, bemerkungen: "" },
    { id: "LP006", name: "Brunner", faecher: ["Bio", "Chem"], solllektionen: 25, bemerkungen: "" },
    { id: "LP007", name: "Keller", faecher: ["Phys", "M"], solllektionen: 20, bemerkungen: "" },
    { id: "LP008", name: "Huber", faecher: ["Gg", "G"], solllektionen: 23, geburtsdatum: "1968-03-15", bemerkungen: "Altersentlastung" },
    { id: "LP009", name: "Steiner", faecher: ["BG", "Mu"], solllektionen: 16, bemerkungen: "" },
    { id: "LP010", name: "Bauer", faecher: ["Sport"], solllektionen: 23, bemerkungen: "" },
    { id: "LP011", name: "Graf", faecher: ["W&R", "G"], solllektionen: 20, bemerkungen: "" },
    { id: "LP012", name: "Frei", faecher: ["L", "D"], solllektionen: 23, bemerkungen: "" },
    { id: "LP013", name: "Widmer", faecher: ["E", "Sp"], solllektionen: 26, bemerkungen: "" },
    { id: "LP014", name: "Roth", faecher: ["Phil", "Psych"], solllektionen: 15, bemerkungen: "Teilzeit" },
  ];

  // Klassen across different stufen and profiles
  const klassen = [
    { id: "KL001", name: "1a", stufe: 1, profil: "US", bestand: 24, semester: "FS" as const, schuljahr: 2025, klassenlehrerId: "LP001" },
    { id: "KL002", name: "1b", stufe: 1, profil: "US", bestand: 22, semester: "FS" as const, schuljahr: 2025, klassenlehrerId: "LP002" },
    { id: "KL003", name: "2a", stufe: 2, profil: "US", bestand: 25, semester: "FS" as const, schuljahr: 2025, klassenlehrerId: "LP004" },
    { id: "KL004", name: "2b", stufe: 2, profil: "US", bestand: 23, semester: "FS" as const, schuljahr: 2025, klassenlehrerId: "LP006" },
    { id: "KL005", name: "3a", stufe: 3, profil: "L/E", bestand: 18, semester: "FS" as const, schuljahr: 2025, klassenlehrerId: "LP012" },
    { id: "KL006", name: "3b", stufe: 3, profil: "I/E", bestand: 16, semester: "FS" as const, schuljahr: 2025, klassenlehrerId: "LP003" },
    { id: "KL007", name: "3c", stufe: 3, profil: "Sp/E", bestand: 14, semester: "FS" as const, schuljahr: 2025, klassenlehrerId: "LP013" },
    { id: "KL008", name: "4a", stufe: 4, profil: "L/E", bestand: 20, semester: "FS" as const, schuljahr: 2025, klassenlehrerId: "LP008" },
    { id: "KL009", name: "4b", stufe: 4, profil: "I/E", bestand: 17, semester: "FS" as const, schuljahr: 2025, klassenlehrerId: null },
    { id: "KL010", name: "5a", stufe: 5, profil: "L/E", bestand: 19, semester: "FS" as const, schuljahr: 2025, klassenlehrerId: "LP011" },
    { id: "KL011", name: "5b", stufe: 5, profil: "Sp/E", bestand: 15, semester: "FS" as const, schuljahr: 2025, klassenlehrerId: null },
    { id: "KL012", name: "6a", stufe: 6, profil: "L/E", bestand: 21, semester: "FS" as const, schuljahr: 2025, klassenlehrerId: "LP005" },
  ];

  // Generate zuteilungen
  const zuteilungen = [
    // Deutsch - LP001 (Müller) and LP002 (Meier) and LP012 (Frei)
    { id: "ZT001", lpId: "LP001", klasseId: "KL001", fachId: getFachId("D"), typ: "Standard" as const, lektionen: 5, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 5, bemerkungen: "" },
    { id: "ZT002", lpId: "LP001", klasseId: "KL003", fachId: getFachId("D"), typ: "Standard" as const, lektionen: 4, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 4, bemerkungen: "" },
    { id: "ZT003", lpId: "LP002", klasseId: "KL002", fachId: getFachId("D"), typ: "Standard" as const, lektionen: 5, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 5, bemerkungen: "" },
    { id: "ZT004", lpId: "LP002", klasseId: "KL004", fachId: getFachId("D"), typ: "Standard" as const, lektionen: 4, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 4, bemerkungen: "" },
    { id: "ZT005", lpId: "LP012", klasseId: "KL005", fachId: getFachId("D"), typ: "HK" as const, lektionen: 4, hatHk: true, entschaedigungFaktor: 1, entschaedigungStunden: 4, bemerkungen: "" },
    { id: "ZT006", lpId: "LP012", klasseId: "KL008", fachId: getFachId("D"), typ: "HK" as const, lektionen: 4, hatHk: true, entschaedigungFaktor: 1, entschaedigungStunden: 4, bemerkungen: "" },

    // Französisch - LP003 (Schmidt)
    { id: "ZT007", lpId: "LP003", klasseId: "KL001", fachId: getFachId("F"), typ: "Standard" as const, lektionen: 4, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 4, bemerkungen: "" },
    { id: "ZT008", lpId: "LP003", klasseId: "KL002", fachId: getFachId("F"), typ: "Standard" as const, lektionen: 4, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 4, bemerkungen: "" },
    { id: "ZT009", lpId: "LP003", klasseId: "KL003", fachId: getFachId("F"), typ: "Standard" as const, lektionen: 3, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 3, bemerkungen: "" },
    { id: "ZT010", lpId: "LP003", klasseId: "KL006", fachId: getFachId("F"), typ: "HK" as const, lektionen: 3, hatHk: true, entschaedigungFaktor: 1, entschaedigungStunden: 3, bemerkungen: "" },

    // Englisch - LP002 (Meier) and LP013 (Widmer)
    { id: "ZT011", lpId: "LP013", klasseId: "KL001", fachId: getFachId("E"), typ: "Standard" as const, lektionen: 4, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 4, bemerkungen: "" },
    { id: "ZT012", lpId: "LP013", klasseId: "KL003", fachId: getFachId("E"), typ: "Standard" as const, lektionen: 3, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 3, bemerkungen: "" },
    { id: "ZT013", lpId: "LP002", klasseId: "KL005", fachId: getFachId("E"), typ: "HK" as const, lektionen: 3, hatHk: true, entschaedigungFaktor: 1, entschaedigungStunden: 3, bemerkungen: "" },
    { id: "ZT014", lpId: "LP013", klasseId: "KL007", fachId: getFachId("E"), typ: "HK" as const, lektionen: 3, hatHk: true, entschaedigungFaktor: 1, entschaedigungStunden: 3, bemerkungen: "" },

    // Mathematik - LP004 (Weber), LP005 (Fischer), LP007 (Keller)
    { id: "ZT015", lpId: "LP004", klasseId: "KL001", fachId: getFachId("M"), typ: "Standard" as const, lektionen: 5, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 5, bemerkungen: "" },
    { id: "ZT016", lpId: "LP004", klasseId: "KL002", fachId: getFachId("M"), typ: "Standard" as const, lektionen: 5, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 5, bemerkungen: "" },
    { id: "ZT017", lpId: "LP005", klasseId: "KL003", fachId: getFachId("M"), typ: "Standard" as const, lektionen: 4, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 4, bemerkungen: "" },
    { id: "ZT018", lpId: "LP005", klasseId: "KL004", fachId: getFachId("M"), typ: "Standard" as const, lektionen: 4, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 4, bemerkungen: "" },
    { id: "ZT019", lpId: "LP007", klasseId: "KL005", fachId: getFachId("M"), typ: "Standard" as const, lektionen: 4, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 4, bemerkungen: "" },
    { id: "ZT020", lpId: "LP007", klasseId: "KL008", fachId: getFachId("M"), typ: "Standard" as const, lektionen: 4, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 4, bemerkungen: "" },

    // Biologie & Chemie - LP006 (Brunner)
    { id: "ZT021", lpId: "LP006", klasseId: "KL001", fachId: getFachId("Bio"), typ: "Standard" as const, lektionen: 2, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 2, bemerkungen: "" },
    { id: "ZT022", lpId: "LP006", klasseId: "KL002", fachId: getFachId("Bio"), typ: "Standard" as const, lektionen: 2, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 2, bemerkungen: "" },
    { id: "ZT023", lpId: "LP006", klasseId: "KL003", fachId: getFachId("Chem"), typ: "Standard" as const, lektionen: 2, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 2, bemerkungen: "" },
    { id: "ZT024", lpId: "LP006", klasseId: "KL004", fachId: getFachId("Chem"), typ: "Standard" as const, lektionen: 2, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 2, bemerkungen: "" },
    { id: "ZT025", lpId: "LP006", klasseId: "KL005", fachId: getFachId("Bio"), typ: "Standard" as const, lektionen: 2, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 2, bemerkungen: "" },

    // Physik - LP004 (Weber), LP007 (Keller)
    { id: "ZT026", lpId: "LP004", klasseId: "KL003", fachId: getFachId("Phys"), typ: "Standard" as const, lektionen: 2, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 2, bemerkungen: "" },
    { id: "ZT027", lpId: "LP007", klasseId: "KL004", fachId: getFachId("Phys"), typ: "Standard" as const, lektionen: 2, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 2, bemerkungen: "" },

    // Geografie & Geschichte - LP008 (Huber), LP001 (Müller), LP011 (Graf)
    { id: "ZT028", lpId: "LP008", klasseId: "KL001", fachId: getFachId("Gg"), typ: "Standard" as const, lektionen: 2, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 2, bemerkungen: "" },
    { id: "ZT029", lpId: "LP008", klasseId: "KL002", fachId: getFachId("Gg"), typ: "Standard" as const, lektionen: 2, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 2, bemerkungen: "" },
    { id: "ZT030", lpId: "LP001", klasseId: "KL005", fachId: getFachId("G"), typ: "Standard" as const, lektionen: 2, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 2, bemerkungen: "" },
    { id: "ZT031", lpId: "LP011", klasseId: "KL008", fachId: getFachId("G"), typ: "Standard" as const, lektionen: 2, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 2, bemerkungen: "" },
    { id: "ZT032", lpId: "LP008", klasseId: "KL006", fachId: getFachId("G"), typ: "Standard" as const, lektionen: 2, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 2, bemerkungen: "" },

    // BG & Musik - LP009 (Steiner)
    { id: "ZT033", lpId: "LP009", klasseId: "KL001", fachId: getFachId("BG"), typ: "Standard" as const, lektionen: 2, hatHk: true, entschaedigungFaktor: 1, entschaedigungStunden: 2, bemerkungen: "" },
    { id: "ZT034", lpId: "LP009", klasseId: "KL002", fachId: getFachId("BG"), typ: "Standard" as const, lektionen: 2, hatHk: true, entschaedigungFaktor: 1, entschaedigungStunden: 2, bemerkungen: "" },
    { id: "ZT035", lpId: "LP009", klasseId: "KL003", fachId: getFachId("Mu"), typ: "Standard" as const, lektionen: 2, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 2, bemerkungen: "" },
    { id: "ZT036", lpId: "LP009", klasseId: "KL004", fachId: getFachId("Mu"), typ: "Standard" as const, lektionen: 2, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 2, bemerkungen: "" },

    // Sport - LP010 (Bauer)
    { id: "ZT037", lpId: "LP010", klasseId: "KL001", fachId: getFachId("Sport"), typ: "Standard" as const, lektionen: 3, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 3, bemerkungen: "" },
    { id: "ZT038", lpId: "LP010", klasseId: "KL002", fachId: getFachId("Sport"), typ: "Standard" as const, lektionen: 3, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 3, bemerkungen: "" },
    { id: "ZT039", lpId: "LP010", klasseId: "KL003", fachId: getFachId("Sport"), typ: "Standard" as const, lektionen: 3, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 3, bemerkungen: "" },
    { id: "ZT040", lpId: "LP010", klasseId: "KL004", fachId: getFachId("Sport"), typ: "Standard" as const, lektionen: 3, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 3, bemerkungen: "" },
    { id: "ZT041", lpId: "LP010", klasseId: "KL005", fachId: getFachId("Sport"), typ: "Standard" as const, lektionen: 3, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 3, bemerkungen: "" },
    { id: "ZT042", lpId: "LP010", klasseId: "KL006", fachId: getFachId("Sport"), typ: "Standard" as const, lektionen: 3, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 3, bemerkungen: "" },

    // Informatik - LP005 (Fischer)
    { id: "ZT043", lpId: "LP005", klasseId: "KL001", fachId: getFachId("Inf"), typ: "Standard" as const, lektionen: 2, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 2, bemerkungen: "" },
    { id: "ZT044", lpId: "LP005", klasseId: "KL002", fachId: getFachId("Inf"), typ: "Standard" as const, lektionen: 2, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 2, bemerkungen: "" },
    { id: "ZT045", lpId: "LP005", klasseId: "KL005", fachId: getFachId("Inf"), typ: "Standard" as const, lektionen: 2, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 2, bemerkungen: "" },

    // W&R - LP011 (Graf)
    { id: "ZT046", lpId: "LP011", klasseId: "KL005", fachId: getFachId("W&R"), typ: "Standard" as const, lektionen: 2, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 2, bemerkungen: "" },
    { id: "ZT047", lpId: "LP011", klasseId: "KL006", fachId: getFachId("W&R"), typ: "Standard" as const, lektionen: 2, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 2, bemerkungen: "" },
    { id: "ZT048", lpId: "LP011", klasseId: "KL008", fachId: getFachId("W&R"), typ: "Standard" as const, lektionen: 2, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 2, bemerkungen: "" },

    // Latein - LP012 (Frei)
    { id: "ZT049", lpId: "LP012", klasseId: "KL005", fachId: getFachId("L"), typ: "HK" as const, lektionen: 4, hatHk: true, entschaedigungFaktor: 1, entschaedigungStunden: 4, bemerkungen: "" },
    { id: "ZT050", lpId: "LP012", klasseId: "KL008", fachId: getFachId("L"), typ: "HK" as const, lektionen: 4, hatHk: true, entschaedigungFaktor: 1, entschaedigungStunden: 4, bemerkungen: "" },
    { id: "ZT051", lpId: "LP012", klasseId: "KL010", fachId: getFachId("L"), typ: "HK" as const, lektionen: 4, hatHk: true, entschaedigungFaktor: 1, entschaedigungStunden: 4, bemerkungen: "" },

    // Italienisch - LP003 (Schmidt)
    { id: "ZT052", lpId: "LP003", klasseId: "KL006", fachId: getFachId("I"), typ: "HK" as const, lektionen: 4, hatHk: true, entschaedigungFaktor: 1, entschaedigungStunden: 4, bemerkungen: "" },
    { id: "ZT053", lpId: "LP003", klasseId: "KL009", fachId: getFachId("I"), typ: "HK" as const, lektionen: 4, hatHk: true, entschaedigungFaktor: 1, entschaedigungStunden: 4, bemerkungen: "" },

    // Spanisch - LP013 (Widmer)
    { id: "ZT054", lpId: "LP013", klasseId: "KL007", fachId: getFachId("Sp"), typ: "HK" as const, lektionen: 4, hatHk: true, entschaedigungFaktor: 1, entschaedigungStunden: 4, bemerkungen: "" },
    { id: "ZT055", lpId: "LP013", klasseId: "KL011", fachId: getFachId("Sp"), typ: "HK" as const, lektionen: 4, hatHk: true, entschaedigungFaktor: 1, entschaedigungStunden: 4, bemerkungen: "" },

    // Phil & Psych Freifächer - LP014 (Roth)
    { id: "ZT056", lpId: "LP014", klasseId: "KL008", fachId: getFachId("Phil"), typ: "Standard" as const, lektionen: 2, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 2, bemerkungen: "Freifach" },
    { id: "ZT057", lpId: "LP014", klasseId: "KL010", fachId: getFachId("Psych"), typ: "Standard" as const, lektionen: 2, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 2, bemerkungen: "Freifach" },

    // Some zuteilungen without teacher (lpId: null) for demonstration
    { id: "ZT058", lpId: null, klasseId: "KL012", fachId: getFachId("D"), typ: "HK" as const, lektionen: 4, hatHk: true, entschaedigungFaktor: 1, entschaedigungStunden: 4, bemerkungen: "Noch nicht besetzt" },
    { id: "ZT059", lpId: null, klasseId: "KL012", fachId: getFachId("M"), typ: "Standard" as const, lektionen: 4, hatHk: false, entschaedigungFaktor: 1, entschaedigungStunden: 4, bemerkungen: "Noch nicht besetzt" },
  ];

  // Gekoppelte Klassen - combining small classes for certain subjects
  const gekoppelt = [
    { id: "GK001", klasse1Id: "KL005", klasse2Id: "KL006", fachKuerzel: "Sport", schuelerTotal: 34, bemerkungen: "3a + 3b Sport" },
    { id: "GK002", klasse1Id: "KL006", klasse2Id: "KL007", fachKuerzel: "BG", schuelerTotal: 30, bemerkungen: "3b + 3c Bildnerisches Gestalten" },
    { id: "GK003", klasse1Id: "KL008", klasse2Id: "KL009", fachKuerzel: "Sport", schuelerTotal: 37, bemerkungen: "4a + 4b Sport" },
    { id: "GK004", klasse1Id: "KL010", klasse2Id: "KL011", fachKuerzel: "Inf", schuelerTotal: 34, bemerkungen: "5a + 5b Informatik" },
  ];

  return {
    lehrpersonen,
    klassen,
    faecher,
    zuteilungen,
    gekoppelt,
  };
};
